import React from "react";
import { Card, CardContent } from "@mui/material";
import { TwoColumns } from "@soqs/common";
import { Field } from "react-final-form";

import { dropdownopts, currentind } from "../../features/AppSlice";
import { useSelector } from "react-redux";
import SwitchAdapter from "../useradapters/SwitchAdapter";

const AssessmentSwitch = () => {
  const dropdownoptions = useSelector(dropdownopts);
  const current = useSelector(currentind);

  console.log("Assessmentswitch current = " + current);

  return (
    <Card>
      <CardContent>
        {dropdownoptions
          .filter((x) => x.set === "aacurrentindicator")
          .map((x) => (
            <TwoColumns key={x}>
              <Field
                name="aacurrentindicators"
                component={SwitchAdapter}
                type="checkbox"
                label={x.description}
                defaultValue={current === "True" ? true : false}
              />
            </TwoColumns>
          ))}
      </CardContent>
    </Card>
  );
};

export default AssessmentSwitch;
